export default "__VITE_ASSET__CLln7Yt4__"